import {
  DyscalculiaDifficultyLevel,
  DyscalculiaTaskResult,
  DyscalculiaTaskType,
} from "types/testTypes";

export interface DyscalculiaDifficultyLadder {
  effect: string;
}

export const DYSCALCULIA_DIFFICULTY_LEVELS: DyscalculiaDifficultyLevel[] = [1, 2, 3, 4];

export const DYSCALCULIA_DIFFICULTY_STATUS_PRESENTATION = {
  highAccuracy: { label: "High accuracy · 80%+", color: "green" },
  lowAccuracy: { label: "Lower accuracy · under 80%", color: "red" },
  notGiven: { label: "Not given", color: "gray" },
} as const;

export type DyscalculiaDifficultyStatus = keyof typeof DYSCALCULIA_DIFFICULTY_STATUS_PRESENTATION;

export const DYSCALCULIA_DIFFICULTY_LEVEL_PRESENTATION: Record<
  DyscalculiaDifficultyLevel,
  { title: string }
> = {
  1: { title: "Foundational" },
  2: { title: "Intermediate" },
  3: { title: "Challenging" },
  4: { title: "Most challenging" },
};

const LADDERS_BY_TASK_TYPE: Record<DyscalculiaTaskType, DyscalculiaDifficultyLadder | null> = {
  magnitudeComparisonSymbolic: {
    effect: "Numbers that are closer together are harder to compare.",
  },
  numberLine: {
    effect: "Positions near the start of the line are usually harder to estimate accurately.",
  },
  magnitudeComparisonNonSymbolic: {
    effect: "Dot groups with more similar amounts are harder to compare.",
  },
  dotEnumeration: {
    effect:
      "Up to about four dots can be recognized at a glance; larger groups usually need counting.",
  },
  stroop: null,
};

const FRACTION_COMPARISON_LADDER: DyscalculiaDifficultyLadder = {
  effect: "Fractions are harder when whole-number shortcuts no longer work.",
};

export function difficultyLadderForTask(
  task: Pick<DyscalculiaTaskResult, "taskType" | "taskId">,
): DyscalculiaDifficultyLadder | null {
  return task.taskType === "magnitudeComparisonSymbolic" &&
    task.taskId?.includes("fraction_compare")
    ? FRACTION_COMPARISON_LADDER
    : LADDERS_BY_TASK_TYPE[task.taskType];
}
